<script module lang="ts">
  export type FilterChip = {
    id: string;
    label: string;
    /** Omit (rather than pass 0) to render the chip without a count capsule. */
    count?: number;
    /** Hex color for the leading dot; omit for no dot. */
    dot?: string;
    /** Per-chip active flag — only consulted when `activeId` isn't given. */
    active?: boolean;
  };
</script>

<script lang="ts">
  // A row of pill filters that reorganize an already-loaded list. Kept
  // deliberately dumb: the page owns the filter state and the counts, this
  // only renders + reports clicks, so it drops into any list page.
  let {
    chips,
    activeId,
    onSelect,
    ariaLabel = 'Filters',
    class: extraClass = ''
  }: {
    chips: FilterChip[];
    /** Selected chip id. When undefined, each chip's own `active` is used. */
    activeId?: string;
    onSelect: (id: string) => void;
    ariaLabel?: string;
    class?: string;
  } = $props();

  const isActive = (chip: FilterChip) => (activeId !== undefined ? chip.id === activeId : !!chip.active);
</script>

<!-- `tym-chip-row` is what makes this pan horizontally (rather than wrap)
     below `sm` — see app.css; it's on this root only, never on the outer
     `.tym-filter-bar` a page may also be using as its filter container. -->
<div class="tym-filter-bar tym-chip-row {extraClass}" role="group" aria-label={ariaLabel}>
  {#each chips as chip (chip.id)}
    <button
      type="button"
      class="tym-chip tym-chip-sm capitalize {isActive(chip) ? 'active' : ''}"
      aria-pressed={isActive(chip)}
      onclick={() => onSelect(chip.id)}
    >
      {#if chip.dot}
        <span class="tym-chip-dot" style="background:{chip.dot}"></span>
      {/if}
      {chip.label}
      {#if chip.count !== undefined}
        <span class="tym-chip-count">{chip.count}</span>
      {/if}
    </button>
  {/each}
</div>
